import { FC } from 'react'
import TooltipProvider from './TooltipProvider'

import { t } from 'translations'

interface BillableIconProps {
  isBillable?: boolean
}

const BillableIcon: FC<BillableIconProps> = ({ isBillable = true }) => {
  return (
    <TooltipProvider tooltip={isBillable ? t(`manager.users.BILLABLE`) : t(`manager.users.NOT_BILLABLE`)}>
      <i className={`${isBillable ? `text-success` : `text-muted`} fa-solid fa-dollar-sign`} />
    </TooltipProvider>
  )
}

export default BillableIcon
